import DS_logo from '@/assets/img/logo/DS_logo.png'
import AMB_logo from '@/assets/img/logo/AMB_logo.png'
import TP_logo from '@/assets/img/logo/TP_logo.png'
import ZB_logo from '@/assets/img/logo/ZB_logo.png'

// 對應oper
export const mapList = [
  '3c52c77d',
  '520c7eb3',
  '77b21973',
]
// 對應oper hidden
export const mapHiddenList = [
	'99dd7845',
]

// 對應 DSoper hidden
export const mapDSList = [
  '1d53c16a',
]

// 對應oper廠商名稱與logo路徑
export const mapOperList = {
  '1d53c16a': { name: 'DS', logoPath: DS_logo },
  '3c52c77d': { name: 'TP', logoPath: TP_logo },
  '520c7eb3': { name: 'AMB', logoPath: AMB_logo },
  '77b21973': { name: 'ZB', logoPath: ZB_logo },
}

// Banner 指定排序
export const bannerSort = [
  'banner20', // 3089
  'banner19', // 3086
  'banner18', // 3085
  'banner17', // 3088
  'banner16', // 3601
  'banner13', // 1012
  'banner01', // 1003
]

// Banner 圖片格式
export const bannerType = 'jpg'

// 對應語系設定
export const mapLang = {
  'en_us': {
    title: 'English',
    img: 'en',
    key: 'en_us'
  },
  'zh_cn': {
    title: '中文',
    img: 'cn',
    key: 'zh_cn'
  },
  'vi_vn': {
    title: 'Tiếng Việt',
    img: 'vn',
    key: 'vi_vn'
  },
  'th_th': {
    title: 'ภาษาไทย',
    img: 'th',
    key: 'th_th'
  },
  'id_id': {
    title: 'Bahasa Indonesia',
    img: 'id',
    key: 'id_id'
  },
  'zh_hk': { // 取得url語系參數要顯示，但不顯示語系logo與選單
    title: '中文(香港)',
    img: 'hk',
    key: 'zh_hk'
  },
  'ko_kr': {
    title: '한국어',
    img: 'kr',
    key: 'ko_kr'
  },
  'ja_jp': {
    title: '日本語',
    img: 'ja',
    key: 'ja_jp'
  },
  'pt_pt': {
    title: 'Português',
    img: 'pt',
    key: 'pt_pt'
  },
  'es_es': {
    title: 'Español',
    img: 'es',
    key: 'es_es'
  },
  'bn_bd': {
    title: 'বাংলা',
    img: 'bn',
    key: 'bn_bd'
  },
  'hi_in': {
    title: 'हिंदी',
    img: 'hi',
    key: 'hi_in'
  },
  'fr_fr': {
    title: 'français',
    img: 'fr',
    key: 'fr_fr'
  }
}

// 例外語系對應設定
export const mapLangFallback = {
  'bn_bd': 'en_us',
  'hi_in': 'en_us',
  'fr_fr': 'en_us'
}

